// extracted by mini-css-extract-plugin
export default {"bentoPanel":"BentoPanel_bentoPanel__LHQ2I","grid":"BentoPanel_grid__AskEm","bentoItem":"BentoPanel_bentoItem__Gm5hd"};